import { render, staticRenderFns } from "./PolaroidSection.vue?vue&type=template&id=7f8ef2a6&scoped=true&"
import script from "./PolaroidSection.vue?vue&type=script&lang=js&"
export * from "./PolaroidSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ef2a6",
  null
  
)

export default component.exports